module.exports = __webpack_public_path__ + "img/UMUC-logo.36e29299.svg";